export default __webpack_public_path__ + "static/media/pictogramTerminalEssential128.38053ffd.png";